import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    PageTitle,
    Input,
    Button as CustomButton,
    Loading,
    Picker
} from '../root/components/common'
import { CircularProgress } from '@material-ui/core'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter } from 'react-router-dom'
import * as actions from './actions'
import { enqueueSnackbar } from '../root/actions'
import { IconButton } from '@material-ui/core'
import * as clipboard from 'clipboard-polyfill/text'
import CopyIcon from '@material-ui/icons/FileCopyOutlined'
import { UserPermissions } from '../../services/permissions'
import { NEW_LOCATION_ID } from './constants'
import { isEmpty } from 'lodash'
import {
    mdiCheckCircleOutline,
    mdiAlertCircleOutline,
    mdiCloseCircleOutline,
    mdiPower
} from '@mdi/js'
import Icon from '@mdi/react'
import { DialogOpener } from '../root/components/common/dialog-opener'
import { LocationCreateModal } from './components/location-create-modal'
import { useAddressApi } from '../root/hooks/use-address-api'
import { Autocomplete } from '@material-ui/lab'
import { FilesIcon } from 'lucide-react'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    detailsWrapper: {
        width: 500,
        marginTop: 40
    },
    input: {
        marginBottom: 16
    },
    devicesAmountWrapper: {
        marginBottom: 16
    },
    picker: {
        border: theme.border,
        padding: '0 8px',
        borderRadius: 7,
        width: '150px',
        flex: 1
    },
    button: {
        marginBottom: 8,
        marginTop: 16
    },
    locationsPathWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 20,
        marginBottom: 20
    },
    copyButton: {
        /* marginLeft: '-15px' */
    },
    row: {
        display: 'flex',
        margin: '16px 0',
        justifyContent: 'space-between'
    },
    rowTitle: {
        marginRight: 15,
        flex: 1,
        alignItems: 'center'
    },
    rowTitleBig: {
        marginRight: 15,
        fontSize: 16
    },
    butttonsBlock: {
        marginTop: 40
    },
    responsibleTitle: {
        marginBottom: 8
    },
    buttonSection: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 40,
        paddingBottom: 40
    },
    deviceIcons: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        marginRight: 55
    },
    pathIcon: {
        flex: 1,
        display: 'flex'
    },
    locationPath: {
        maxWidth: 225,
        wordWrap: 'break-word',
        display: 'flex',
        alignItems: 'center'
    },
    escalationLevelsBtn: {
        fontWeight: 'bold',
        marginTop: 10
    }
}))

function Location(props) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const locationId = props.match.params.locationId
    const { location, locations } = useSelector(state => state.locations)
    const locationFromList =
        !isEmpty(locations) && location
            ? locations.find(l => l.id === location.id)
            : null
    const history = useHistory()
    const { p, isLoading, locale, theme } = useSelector(state => state.main)

    const loggedInUser = useSelector(state => state.main.user)
    const { pickerLocations, selectLocation, onAddSubLocation } = props
    const permissions = {
        updateLocation: UserPermissions.location(
            location && location.customer_id
        ).update,
        createLocation: UserPermissions.location(
            location && location.customer_id
        ).create,
        share:
            (UserPermissions.device(loggedInUser.original_customer_id).create,
            UserPermissions.location(loggedInUser.original_customer_id).create)
    }
    const [name, setName] = useState(location ? location.name || '' : '')
    const [address, setAddress] = useState(
        location ? location.address || '' : ''
    )
    const [parentId, setParentId] = useState(
        location ? location.parent_id || '' : ''
    )
    const isNewLocation = locationId === NEW_LOCATION_ID

    const [contactMail, setContactMail] = useState(
        location ? location.contact_email || '' : ''
    )
    const [contactName, setContactName] = useState(
        location ? location.contact_name || '' : ''
    )
    const [contactPhone, setContactPhone] = useState(
        location ? location.contact_phone_number || '' : ''
    )

    const {
        foundAddresses,
        isLoadingAddress,
        addressSearchString,
        setAddressSearchString,
        clearSearchString
    } = useAddressApi()

    const isValid = data => {
        let ok = true
        if (!data.name || data.name.length === '') {
            ok = false
            dispatch(
                enqueueSnackbar({
                    message: locale.locations.nameCanNotBeEmpty,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
        return ok
    }

    const save = (data, isNew, id) => {
        if (isValid(data)) {
            if (!data.parent_id && !isNew) delete data.parent_id
            dispatch(
                isNew
                    ? actions.locationCreateRequest(data, history)
                    : actions.locationUpdateRequest(id, data)
            )
        }
    }

    const copyToClipboard = async value => {
        try {
            await clipboard.writeText(value)
            dispatch(
                enqueueSnackbar({
                    message: locale.common.copied,
                    options: {
                        variant: 'success'
                    }
                })
            )
        } catch (ex) {
            dispatch(
                enqueueSnackbar({
                    message: locale.common.failedToCopy,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
    }

    useEffect(() => {
        setName(location ? location.name || '' : '')
        setAddress(location ? location.address || '' : '')
        setParentId(location ? location.parent_id || '' : '')
        setContactMail(location ? location.contact_email || '' : '')
        setContactName(location ? location.contact_name || '' : '')
        setContactPhone(location ? location.contact_phone_number || '' : '')
    }, [location])

    return (
        <div className={classes.wrapper}>
            {isLoading && <Loading />}
            {!isLoading && location && (
                <React.Fragment>
                    <PageTitle title={location.name} />
                    <div className={classes.detailsWrapper}>
                        <Input
                            className={classes.input}
                            label={locale.common.name}
                            type="text"
                            setValue={setName}
                            value={name}
                            autoFocus={isNewLocation}
                            onEnter={save.bind(
                                this,
                                {
                                    name: name,
                                    address: address,
                                    parent_id:
                                        parentId === ''
                                            ? null
                                            : Number(parentId),
                                    customer_id: Number(location.customer_id),
                                    owner_id: Number(location.owner_id)
                                },
                                isNewLocation,
                                locationId
                            )}
                            disabled={!permissions.updateLocation}
                        />
                        {location.parent_id && (
                            <div className={classes.row}>
                                <div className={classes.rowTitle}>
                                    {locale.locations.parentLocation}:
                                </div>
                                <Picker
                                    className={classes.picker}
                                    disabled={
                                        !permissions.updateLocation ||
                                        isNewLocation
                                    }
                                    onChange={setParentId}
                                    value={parentId}
                                    options={pickerLocations}
                                />
                            </div>
                        )}
                        {location.parent_id &&
                            !isNewLocation &&
                            location.locations_path && (
                                <div className={classes.row}>
                                    <div className={classes.rowTitle}>
                                        {locale.locations.locationsPath}:
                                    </div>
                                    <div className={classes.pathIcon}>
                                        <div className={classes.locationPath}>
                                            {location.locations_path}
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                marginLeft: 8
                                            }}
                                        >
                                            <IconButton
                                                className={classes.copyButton}
                                                size="small"
                                                onClick={copyToClipboard.bind(
                                                    this,
                                                    location.locations_path
                                                )}
                                            >
                                                <FilesIcon size={18} />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {!isNewLocation && location.id && (
                            <div className={classes.row}>
                                <div className={classes.rowTitle}>
                                    {locale.locations.locationId}:
                                </div>
                                <div className={classes.pathIcon}>
                                    <div className={classes.locationPath}>
                                        {location.id}
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginLeft: 8
                                        }}
                                    >
                                        <IconButton
                                            className={classes.copyButton}
                                            size="small"
                                            onClick={copyToClipboard.bind(
                                                this,
                                                location.id
                                            )}
                                        >
                                            <FilesIcon size={18} />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!isNewLocation && (
                            <div className={classes.row}>
                                <div style={{ flex: 1 }}>
                                    {locale.locations.devices}:
                                </div>
                                <div style={{ flex: 1 }}>
                                    {location.devices_count +
                                        ' ' +
                                        locale.locations.devices}
                                </div>
                            </div>
                        )}
                        {!isNewLocation && locationFromList && (
                            <div className={classes.deviceIcons}>
                                <Icon
                                    path={mdiCheckCircleOutline}
                                    size={1.1}
                                    color={theme.active}
                                />
                                <span
                                    style={{
                                        color: theme.active,
                                        marginLeft: 4,
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                        marginRight: 12
                                    }}
                                >
                                    {locationFromList.devices_active}
                                </span>
                                <Icon
                                    path={mdiCloseCircleOutline}
                                    size={1.1}
                                    color={theme.error}
                                />
                                <span
                                    style={{
                                        color: theme.error,
                                        marginLeft: 4,
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                        marginRight: 12
                                    }}
                                >
                                    {locationFromList.devices_critical}
                                </span>
                                <Icon
                                    path={mdiAlertCircleOutline}
                                    size={1.1}
                                    color={theme.warning}
                                />
                                <span
                                    style={{
                                        color: theme.warning,
                                        marginLeft: 4,
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                        marginRight: 12
                                    }}
                                >
                                    {locationFromList.devices_warning}
                                </span>
                                <Icon
                                    path={mdiPower}
                                    size={1.1}
                                    color={theme.secondary}
                                />
                                <span
                                    style={{
                                        color: theme.secondary,
                                        marginLeft: 4,
                                        fontWeight: 'bold',
                                        fontSize: 12,
                                        marginRight: 12
                                    }}
                                >
                                    {locationFromList.devices_inactive}
                                </span>
                            </div>
                        )}
                        <div style={{ marginTop: 50 }}>
                            <h3
                                style={{
                                    fontSize: 16,
                                    fontWeight: 'normal'
                                }}
                            >
                                {locale.locations.locationDetails}
                            </h3>
                            <div>
                                <Autocomplete
                                    options={foundAddresses}
                                    noOptionsText={
                                        locale.detachedSharing.nothingFound
                                    }
                                    className={classes.input}
                                    renderInput={params => {
                                        return (
                                            <Input
                                                type="text"
                                                {...params}
                                                label={locale.locations.address}
                                                variant="outlined"
                                                value={addressSearchString}
                                                setValue={v => {
                                                    setAddress(v)
                                                    setAddressSearchString(v)
                                                }}
                                                debounce={300}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {isLoadingAddress ? (
                                                                <CircularProgress
                                                                    size={20}
                                                                />
                                                            ) : null}
                                                            {address &&
                                                                params
                                                                    .InputProps
                                                                    .endAdornment}
                                                        </>
                                                    )
                                                }}
                                            />
                                        )
                                    }}
                                    onChange={(e, newValue) => {
                                        setAddress(newValue)

                                        if (!newValue) {
                                            clearSearchString()
                                        }
                                    }}
                                    value={address}
                                    disabled={!permissions.updateLocation}
                                />
                                <Input
                                    className={classes.input}
                                    label={locale.locations.contact}
                                    type="text"
                                    setValue={setContactName}
                                    value={contactName}
                                    onEnter={save.bind(
                                        this,
                                        {
                                            name: name,
                                            address: address,
                                            contact_name: contactName,
                                            contact_email: contactMail,
                                            contact_phone_number: contactPhone,
                                            parent_id:
                                                parentId === ''
                                                    ? null
                                                    : Number(parentId),
                                            customer_id: Number(
                                                location.customer_id
                                            ),
                                            owner_id: Number(location.owner_id)
                                        },
                                        isNewLocation,
                                        locationId
                                    )}
                                    disabled={!permissions.updateLocation}
                                />
                                <Input
                                    className={classes.input}
                                    label={locale.locations.contactPhone}
                                    type="text"
                                    setValue={setContactPhone}
                                    value={contactPhone}
                                    onEnter={save.bind(
                                        this,
                                        {
                                            name: name,
                                            address: address,
                                            contact_name: contactName,
                                            contact_email: contactMail,
                                            contact_phone_number: contactPhone,
                                            parent_id:
                                                parentId === ''
                                                    ? null
                                                    : Number(parentId),
                                            customer_id: Number(
                                                location.customer_id
                                            ),
                                            owner_id: Number(location.owner_id)
                                        },
                                        isNewLocation,
                                        locationId
                                    )}
                                    disabled={!permissions.updateLocation}
                                />
                                <Input
                                    className={classes.input}
                                    label={locale.locations.locationEmail}
                                    type="text"
                                    setValue={setContactMail}
                                    value={contactMail}
                                    onEnter={save.bind(
                                        this,
                                        {
                                            name: name,
                                            address: address,
                                            contact_name: contactName,
                                            contact_email: contactMail,
                                            contact_phone_number: contactPhone,
                                            parent_id:
                                                parentId === ''
                                                    ? null
                                                    : Number(parentId),
                                            customer_id: Number(
                                                location.customer_id
                                            ),
                                            owner_id: Number(location.owner_id)
                                        },
                                        isNewLocation,
                                        locationId
                                    )}
                                    disabled={!permissions.updateLocation}
                                />
                            </div>
                        </div>
                        <div className={classes.buttonSection}>
                            {permissions.createLocation && !isNewLocation && (
                                <DialogOpener
                                    dialog={(handleClose, modalProps) => {
                                        return modalProps.open ? (
                                            <LocationCreateModal
                                                onClose={() => {
                                                    handleClose()
                                                }}
                                                modalProps={modalProps}
                                                parentId={locationId}
                                                pickerLocations={
                                                    pickerLocations
                                                }
                                                parentLocation={location}
                                            />
                                        ) : null
                                    }}
                                >
                                    {handleOpen => (
                                        <CustomButton
                                            reverted
                                            disabled={
                                                !permissions.createLocation
                                            }
                                            onClick={handleOpen}
                                        >
                                            {locale.locations.addSubLocation}
                                        </CustomButton>
                                    )}
                                </DialogOpener>
                            )}
                            {permissions.updateLocation && (
                                <CustomButton
                                    disabled={!permissions.updateLocation}
                                    onClick={save.bind(
                                        this,
                                        {
                                            name: name,
                                            address: address,
                                            contact_name: contactName,
                                            contact_email: contactMail,
                                            contact_phone_number: contactPhone,
                                            parent_id:
                                                parentId === ''
                                                    ? null
                                                    : Number(parentId),
                                            customer_id: Number(
                                                location.customer_id
                                            ),
                                            owner_id: Number(location.owner_id)
                                        },
                                        isNewLocation,
                                        locationId
                                    )}
                                >
                                    {locale.common.save}
                                </CustomButton>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            )}
            {!isLoading && !location && (
                <div>{locale.locations.locationNotFound}</div>
            )}
        </div>
    )
}

export default withRouter(Location)
